import script from "./MemorialDashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MemorialDashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./MemorialDashboardPage.vue?vue&type=style&index=0&id=54b2dac3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b2dac3"]])

export default __exports__